import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import './assets/fonts/fonts.css'; // Custom fonts
import './styles/themeVariables.css'; // Theme CSS variables (dynamically updated by ThemeContext)
import './styles/globalColors.css'; // Global styles (scrollbars, headings, etc.)
import './styles/globalComponents.css'; // Global table and button styles

// Ensure all axios requests include session cookies, even on same-origin.
// Without this, some browsers (especially Chrome desktop after network changes)
// may not send the connect.sid cookie, causing 401 errors across the app.
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
